import { render } from "./ActivityNavigation.vue?vue&type=template&id=1b0c6c7e"
import script from "./ActivityNavigation.vue?vue&type=script&lang=js"
export * from "./ActivityNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script